<script lang="ts">
  import Loader from "./icons/Loader.svelte";

  const { title, isD2CFlow = false }: { title: string; isD2CFlow?: boolean } = $props();
</script>

<h3 class={[{ "d2c-flow": isD2CFlow }]}>{title}</h3>
<div class="loader-container">
  <Loader height="150px" width="60px" />
</div>

<style lang="scss">
  h3 {
    &.d2c-flow {
      font-family: "EB Garamond";
    }
  }
  .loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    align-self: center;
  }
</style>
